import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProductController from '../../apis/controller/ourProducts.controller';
import { renderImage } from '../../Components/helper/image';
import { stripTags } from '../../Components/helper/General';
import Slider from "react-slick";
import Banner_1 from '../../assets/images/banner_1.jpg';

function Productdetail(props) {
    const [productDetail, setProductdetail] = useState();
    const [loader, setLoader] = useState(false);
    let param = useParams();
    useEffect(() => {
        getProductDetails();
        window.scrollTo(0, 0);
    }, [param.slug]);


    const getProductDetails = async () => {
        setLoader(true);
        let res = await new ProductController().productsDetails(param.slug);
        if (res && res.status) {
            setProductdetail(res);
        }
        setLoader(false);
    };
    let uniDetail = props && props.universityDetail
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);

    });
    const settingsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav',
        responsive: [
            {
              breakpoint: 500,
              settings: {
                arrows:false,
              }
            },
        ]
    };

    const settingsThumbs = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '0px',
        margin: 70,
        responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 1
              }
            },
        ]
    };

    const slidesData = [
        {
            id: 1,
           
            image: Banner_1,
        }, {
            id: 2,
            
            image: Banner_1,
        }, {
            id: 3,
           
            image: Banner_1,
        }, {
            id: 4,
           
            image: Banner_1,
        }
    ];

     console.log(uniDetail && uniDetail.image);
    return (
        <>
            {productDetail && productDetail.breadcrumbs ? <PageTitle title={productDetail.breadcrumbs.main_title} image={productDetail.breadcrumbs.image} /> : null}
            {productDetail && productDetail.products && <div className='productdetail_wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-12 col-lg-12 col-sm-12 col-12'>
                            {/* <div className='productdetail_set'>
                                <img src={renderImage(productDetail.products.image, 'medium')} alt="..." className="img-fluid" />
                                <h4>
                                    {productDetail.products.title}
                                </h4>
                                <div dangerouslySetInnerHTML={{ __html: productDetail.products.description }} />
                            </div> */}
                            <div className='product_detail_area_in'>
                                <div className="slider_detail">
                                    <div className="slider-wrapper">
                                        <Slider
                                            {...settingsMain}
                                            asNavFor={nav2}
                                            ref={slider => (setSlider1(slider))} >
                                            {slidesData.map((slide) =>
                                                <div className="slick-slide" key={slide.id}>
                                                    <img className="slick-slide-image" src={slide.image} />
                                                </div>
                                            )}

                                        </Slider>

                                        <div className="thumbnail-slider-wrap">
                                            <Slider
                                                {...settingsThumbs}
                                                asNavFor={nav1}
                                                ref={slider => (setSlider2(slider))}>

                                                {slidesData.map((slide) =>
                                                    <div className="slick-slide" key={slide.id}>
                                                        <img className="slick-slide-image" src={slide.image} />
                                                    </div>
                                                )}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                                <div className='content_of_product'>
                                    <div className='inner_area'>
                                        <h4>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium facere in quis consequatur quae fuga atque. Ex quos dolores perferendis, atque, illo laboriosam quis harum rerum ipsa, aspernatur a beatae.
                                        </p>
                                    </div>
                                    <div className='technology'>
                                        <h5>
                                            Technologyies
                                        </h5>
                                        <ul>
                                            <li>
                                                abc
                                            </li>
                                            <li>
                                                abc
                                            </li>
                                            <li>
                                                abc
                                            </li>
                                            <li>
                                                abc
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='share'>
                                        <h5>
                                            
                                            Share:
                                        </h5>
                                        <ul>
                                            <li><a href="/"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="/"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="/"><i class="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div className='grow_business_set'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-12 col-lg-12 col-sm-12 col-12'>
                            <div className='grow_business'>
                                <div className="left">
                                    <h3>
                                        Grow Your Business and Build Your Website or Software With us.
                                    </h3>
                                </div>
                                <div className="right">
                                    <Link to="" className="btn-primary_set">Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Productdetail;